import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hospitalWarehouse",
  "use": "icon-hospitalWarehouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hospitalWarehouse\"><path d=\"M63.811829 821.816162V309.673979a56.873091 56.873091 0 0 1 56.873091-56.87309h140.931519a56.873091 56.873091 0 0 1 56.873091 56.87309v512.142183H63.811829zM379.912468 821.816162V183.245099a56.873091 56.873091 0 0 1 56.873091-56.873091h140.874646a56.873091 56.873091 0 0 1 56.87309 56.873091v638.571063H379.912468zM702.1554 821.816162V56.873091a56.873091 56.873091 0 0 1 56.873091-56.873091h140.874646a56.873091 56.873091 0 0 1 56.873091 56.873091v764.943071h-254.620828zM1023.715856 826.081644v75.470591a56.873091 56.873091 0 0 1-56.873091 56.873091h-909.969453a56.873091 56.873091 0 0 1-56.873091-56.873091V826.081644a56.873091 56.873091 0 0 1 56.873091-56.873091h909.969453a56.873091 56.873091 0 0 1 56.873091 56.873091z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hospitalWarehouse.svg
// module id = RcHr
// module chunks = 78